import SurveyForm from "../components/SurveyForm";

const CreateStandardSurveyPage = () => <SurveyForm mode="standard" />;

export default CreateStandardSurveyPage;
